import React from "react";
import { CSVLink } from "react-csv";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import searchWhiteIcon from "./Icon.png";
// import "./OMS Purchase.css";
import NavBar from "../NavBar";
import OMSPurchaseCard from "../OMSPurchaseCard";
import { useState } from "react";
export default function OMSPurchaseList(props) {
  const [count, setCount] = useState([]);
  const [filtr1, setFiltr1] = useState("");
  
  const handleFilter1 = (e) => {
    setFiltr1(e.target.value);
    setCount(IncomingData.filter((x) => x.deliveryStatus === e.target.value));
  };
  return (
    
    <>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="account_title">Order Management</span>
          <span className="color"> &#62; </span>
          <span className="color"> Purchase</span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h2>Purchase</h2>
        <div id="Right-content-Down-Filters">
          <div
            style={{
              "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
              height: "80%",
            }}
          ></div>
        </div>
      </div>
      <div id="OMS-main-content">
        <div className="marketplace-table">
          <div id="click-data">
            <p>All Orders</p>
            <p>Confirmed</p>
            <p>Cancelled</p>
          </div>
          <div className="order-list-input-box">
            <div className="order-list-input-left">
            <input
              type="text"
              placeholder="Search by order ID, customer name"
              onChange={(val) => {
                setCount(
                    IncomingData.filter((x) =>
                    x.id.match(val.target.value) || x.customerName.match(val.target.value)
                  )
                );
                setFiltr1("");
              }}
              />              {/* <img src={searchWhiteIcon} alt="" width="" /> */}
            </div>
            <div className="order-list-input-right">
              <select name="" id="" className="order-list-input-right-filters"
               value={filtr1}
              onChange={handleFilter1}
              >
                <option selected>Order Status</option>
                <option value="Delivered">Delivered</option>
                <option value="Not received">Not received</option>
                <option value="Just requested">Just requested</option>
              </select>
              <CSVLink
              data={IncomingData}
              className="supplier-content-input-right-filters"
              style={{ display: "flex", alignItems: "center" }}
            >
              Explore List
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </CSVLink>
            </div>
          </div>
          <table style={{ textAlign: "center" }}>
            <tr>
              <th>Order ID</th>
              <th>Customer Name</th>
              <th>Returned Item</th>
              <th>Purchase Date</th>
              <th>Amount</th>
              <th>Delivery Status</th>
              <th>Payment Method</th>
            </tr>
            {count.length > 0
            ? count.map((val) => {
                return (
                  <tr>
                  <td>{val.id}</td>
                  <td>{val.customerName}</td>
                  <td>{val.returnedItem}</td>
                  <td>{val.purchaseDate}</td>
                  <td>{val.amount}</td>
                  <td className="col-status"
                      id={
                        val.deliveryStatus === "Delivered"
                          ? "col-green"
                          : val.deliveryStatus === "Just requested"
                          ? "red-border-status"
                          : val.deliveryStatus === "Not received"
                          ? "red-border-status"
                          : ""
                      }>{val.deliveryStatus}</td>
                  <td>{val.paymentMethod}</td>
                </tr>
                );
              })
            : IncomingData.map((val) => {
              return (
                <tr>
                  <td>{val.id}</td>
                  <td>{val.customerName}</td>
                  <td>{val.returnedItem}</td>
                  <td>{val.purchaseDate}</td>
                  <td>{val.amount}</td>
                  <td className="col-status"
                      id={
                        val.deliveryStatus === "Delivered"
                          ? "col-green"
                          : val.deliveryStatus === "Just requested"
                          ? "red-border-status"
                          : val.deliveryStatus === "Not received"
                          ? "red-border-status"
                          : ""
                      }>{val.deliveryStatus}</td>
                  <td>{val.paymentMethod}</td>
                </tr>
              );
            })}
          </table>
        </div>
        <OMSPurchaseCard/>
      </div>
    </>
  );
}
export const IncomingData = [
  {id: "KCVF7777",customerName: "Bosco",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Delivered",paymentMethod: "Bank Transfer",},
  {id: "KCVF112L",customerName: "Ron",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Not received",paymentMethod: "Bank Transfer",},
  {id: "KCVF9999",customerName: "Mozilla",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Delivered",paymentMethod: "Bank Transfer",},
  {id: "KCVF112L",customerName: "John Doe",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Just requested",paymentMethod: "Bank Transfer",},
  {id: "KCVF5555",customerName: "John Doe",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Not received",paymentMethod: "Bank Transfer",},
  {id: "KCVF112L",customerName: "John Doe",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Just requested",paymentMethod: "Bank Transfer",},
  {id: "KCVF112L",customerName: "John Doe",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Delivered",paymentMethod: "Bank Transfer",},
  {id: "KCVF112L",customerName: "John Doe",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Not received",paymentMethod: "Bank Transfer",},
  {id: "KCVF112L",customerName: "John Doe",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Delivered",paymentMethod: "Bank Transfer",},
  {id: "KCVF112L",customerName: "John Doe",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Not received",paymentMethod: "Bank Transfer",},
  {id: "KCVF112L",customerName: "John Doe",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Delivered",paymentMethod: "Bank Transfer",},
  {id: "KCVF112L",customerName: "John Doe",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Just requested",paymentMethod: "Bank Transfer",},
  {id: "KCVF112L",customerName: "John Doe",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Delivered",paymentMethod: "Bank Transfer",},
  {id: "KCVF112L",customerName: "John Doe",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Just requested",paymentMethod: "Bank Transfer",},
  {id: "KCVF112L",customerName: "John Doe",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Not received",paymentMethod: "Bank Transfer",},
  {id: "KCVF112L",customerName: "John Doe",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Delivered",paymentMethod: "Bank Transfer",},
  {id: "KCVF112L",customerName: "John Doe",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Delivered",paymentMethod: "Bank Transfer",},
  {id: "KCVF112L",customerName: "John Doe",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Not received",paymentMethod: "Bank Transfer",},
  {id: "KCVF112L",customerName: "John Doe",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Just requested",paymentMethod: "Bank Transfer",},
  {id: "KCVF112L",customerName: "John Doe",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Delivered",paymentMethod: "Bank Transfer",},
  {id: "KCVF112L",customerName: "John Doe",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Delivered",paymentMethod: "Bank Transfer",},
  {id: "KCVF112L",customerName: "John Doe",returnedItem: `Nike men's air zoom shoe`,purchaseDate: '12 - 12 - 12',amount: 9995,deliveryStatus: "Just requested",paymentMethod: "Bank Transfer",},
];